<template>
    <div class="register-section">
        <div class="register-success">
            <img src="../../assets/images/icon-sucess.png">
            <p>恭喜账号注册绑定成功！</p>
        </div>
        <a-form class="register-result">
            <a-form-item v-bind="tailFormItemLayout">
                <div class="register-row">您的登录名为：<span class="phone">{{regInfo.phone}}</span><label>(可用于登陆，密码为新设置的密码)</label></div>
            </a-form-item>
            <a-form-item v-bind="tailFormItemLayout">
                <div class="register-row">绑定账号：<span>{{regInfo.buzzCode}}</span><label>(可用于登陆，密码为新设置的密码)</label></div>
            </a-form-item>
            <a-form-item v-bind="tailFormItemLayout">
                <div class="register-row">昵称：<span>{{regInfo.nickName}}</span></div>
            </a-form-item>
            <a-form-item v-bind="tailFormItemLayout">
                <Button type="primary" @click="gotoPage('workbench')">商家工作台</Button>
                <Button @click="gotoPage('home')">门户首页</Button>
            </a-form-item>
        </a-form>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { Button } from 'ant-design-vue'
import { sessionStore, jump } from '@shared/utils'

export default {
    data() {
        return {
            tailFormItemLayout: {
                wrapperCol: {
                    xs: {
                        span: 24,
                        offset: 0,
                    },
                    sm: {
                        span: 16,
                        offset: 8,
                    },
                },
            },
        }
    },
    computed: {
        ...mapState('register', {
            regInfo: state => state.regInfo
        }),
    },
    async created() {
        if (!this.regInfo.phone) {
            const json = sessionStore.getItem('bindMobile')
            this.setRegInfo(JSON.parse(json) || {})
        } 
    },
    methods: {
        ...mapMutations('register', ['setRegInfo']),
        gotoPage(name) {
            jump.logout(name)
        }
    },
    components: {
        Button
    } 
}
</script>
<style lang="scss" scoped>
.register-success{
    padding-top:40px;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    text-align: center;

    justify-content: center;


    img{
        width: 20px;
        height: 20px;
    }
    p{
        font-size: 16px;
        font-weight: 700;
        color:#333;
        padding-left:10px;
    }
}
.register-result{
    .register-row{
        font-size: 14px;
        color: #666666;
        line-height: 1;

        span{
            font-size: 14px;
            color: #333333;
        }
        label{
            font-size: 12px;
            color: #999999;
        }
        .phone{
            font-size: 14px;
            color: #FF3A00;
            margin-right: 10px;
        }
    }
    .ant-btn-primary{
        background: #1C7AE5;
        border-radius: 2px;
        width: 130px;
        height: 38px;
        font-size: 14px;
        color: #FFFFFF;
    }
    .ant-btn-default{
        background: #F7F7F7;
        border: 1px solid #DBDBDB;
        border-radius: 2px;
        width: 130px;
        height: 38px;
        font-size: 14px;
        color: #333333;
        margin-left: 20px;
    }

}
.register-tip{
    text-align: center;
    font-size: 14px;
    color:#333;

    a{
        text-decoration: underline;
        padding-left: 10px;
    }
}
</style>
